import React, {useEffect, useRef, useState} from "react";
import commonClose from "../../../assets/img/commonClose.png";
import commonInput from "../../../assets/img/commonInput.png";
import {useTranslation} from "react-i18next";
import axios from "../../../services/axiosInstance";
import {useLocation, useNavigate} from "react-router-dom";

function AdminChangeValuePopup({ modifyOneValueSeqNum, beforeOneValue, modifyOneValueType, modifyTrackNum, closeModifyPopup }) {
    const {t} = useTranslation();

    const [value, setValue] = useState("");
    const [valueError, setValueError] = useState(false);

    useEffect(() => {
        if (beforeOneValue && (modifyOneValueType ==="os" || modifyOneValueType === "ds" || modifyOneValueType === "osp")) {
            setValue(beforeOneValue);
        }
    }, [beforeOneValue])

    const [isSaveBtLoading, setIsSaveBtLoading] = useState(false);
    const [isSaveBtDisabled, setIsSaveBtDisabled] = useState(false);

    const handleChangeValue = (e) => {
        setValue(e.target.value);
    }

    const [saveComplMsg, setSaveComplMsg] = useState(false);
    const handleSubmit = () => {
        if (value) {
            setSaveComplMsg(true);
            setTimeout(() => modifyTrackNum(modifyOneValueSeqNum, modifyOneValueType, value), 2000);
        } else {
            setValueError(true);
        }
    }


    return (
        <div className="position-fixed wd-100pc ht-100pc display-flex just-cont-center align-center"
             style={{top: "0", left: "0", zIndex: 1000, background: "rgba(0, 0, 0, 0.3)"}}>
            <div className="wd-400"
                 style={{background: "white", boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)", borderRadius: "6px"}}>
                <div className="wd-100pc"
                     style={{borderBottom: "solid 1px #EAEAEA", height: "70px", display: "flex", padding: "10px"}}>
                    <div className="display-flex align-center justify-content-between wd-100pc p-l-10 p-r-10">
                        <div className="user-center">
                            <div className="ht-100pc display-flex just-cont-center align-center">
                                <img className="wd-30 ht-30" alt='' src={commonInput}/>
                            </div>
                            <div style={{height: "100%", display: "flex", alignItems: "center"}}>
                                <p className="font-t-title font-s-18 m-t-2 m-l-10">값변경 팝업</p>
                            </div>
                        </div>
                        <div className="user-center ht-100pc">
                            <img className="wd-30 ht-30 m-a-opc-07 c-point" onClick={closeModifyPopup}
                                 src={commonClose} alt="close"/>
                        </div>
                    </div>
                </div>

                    <div>
                        <div className="p-l-20 p-r-20 p-b-20">
                            <div
                                className="user-input-container wd-100pc ht-50 display-flex align-center just-cont-center">
                                <input onChange={(e) => handleChangeValue(e)} maxLength={22}
                                       onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                       type="text"
                                       className="user-input wd-100pc ht-45 border-rd4 font-s-14 font-t-cont"
                                       style={{padding: "0 10px", color: "dimgray"}} placeholder="변경값"
                                       value={value}/>
                            </div>
                            {valueError ?
                                <div className="JoinErrorMsg font-t-cont m-t-10">
                                    <p className="JoinErrMsg">값을 입력해주세요</p>
                                </div>
                                :
                                null
                            }

                        </div>
                    </div>


                { saveComplMsg ?
                    <div className="JoinErrorMsg" style={{textAlign: "center"}}>
                        <p className="JoinErrMsg">{t(`eipTx1`)} &#128521;</p>
                    </div>
                    :
                    null
                }

                <div className="display-flex just-cont-fend align-center pd20">
                    <button className="bt-btn-D-B font-s-15" style={{padding: "10px 20px"}}
                            onClick={closeModifyPopup}>
                        <div>Cancel</div>
                    </button>
                    {/*취소버튼*/}

                    <button className="bt-btn-B font-s-15 m-l-10" style={{padding: "10px 20px"}}
                            onClick={handleSubmit} disabled={isSaveBtDisabled}>
                        {isSaveBtLoading ? (
                            <div className="spinner"></div>
                        ) : (
                            <div>Save</div>
                        )}
                    </button>
                    {/*저장버튼*/}
                </div>

            </div>
        </div>
    )
}

export default AdminChangeValuePopup